import { getSupportedFeatures } from '../get-supported-features';
export const extend = Object.assign;
export const now = () => {
    return new Date().getTime();
};
export const addClass = (element, className) => {
    element.classList.add(className);
};
export const convertToHtml = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.firstChild;
};
export const appendHtml = (html, element) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    // use childNodes instead of children
    // to cover text nodes as well
    while (div.childNodes.length > 0) {
        element.appendChild(div.childNodes[0]);
    }
};
export const removeChildren = (element) => {
    while (element.firstChild) {
        element.removeChild(element.firstChild);
    }
};
export const prepend = (element, originElement) => {
    originElement.insertBefore(element, originElement.firstChild);
};
export const wrapInner = (parent, wrapper) => {
    parent.appendChild(wrapper);
    while (parent.firstChild !== wrapper) {
        wrapper.appendChild(parent.firstChild);
    }
};
export const toHyphens = (str) => {
    const result = str.replace(/([a-z][A-Z])/g, function (g) {
        return g.charAt(0) + '-' + g.charAt(1).toLowerCase();
    });
    return result;
};
export const toPixels = (value) => {
    let result;
    if (value && String(value).endsWith('px')) {
        result = value;
    }
    else {
        result = String(value) + 'px';
    }
    return result;
};
export const hasNativeScrolling = () => {
    const { mobileOS } = getSupportedFeatures();
    return mobileOS.ios || mobileOS.android;
};
export const wheelDeltaY = (e) => {
    const deltaY = e.wheelDeltaY;
    let delta;
    if (e.wheelDelta) { // Webkit and IE
        if (deltaY === undefined || deltaY) { // IE does not have deltaY, thus always scroll (horizontal scrolling is treated as vertical)
            delta = e.wheelDelta;
        }
    }
    else if (e.detail && e.axis === e.VERTICAL_AXIS) { // Firefox and Opera
        delta = (-e.detail) * 10;
    }
    return delta;
};
export const renderPos = (pos) => {
    const result = [];
    if (pos) {
        const parts = toHyphens(pos).split('-');
        for (let i = 0; i < parts.length; i++) {
            result.push('k-pos-' + parts[i]);
        }
    }
    return result.join(' ');
};
